import Big from "big.js";
import {Nil} from "./Types";


export const formatPrice = (money: string | number | Big | Nil, currencyCode: string) => {
    // eslint-disable-next-line
    if (money || money == 0) {
        return new Big(money).toNumber().toFixed(2) + " " + currencyCode
    } else {
        return "";
    }
}